import React from 'react';
import './OperationComponent.css'; 
import { CircularProgress } from '@mui/joy';
function OperationComponent({ price, name, client, time, success }) {
    let circleColor = null;
    if(success != null && success !== undefined) {
    circleColor = success == '1' ? 'green' : 'red';
    }
  return (
    <div className="operation-component container">
      <div className="myrow">
          <span className="price text-primary">{price}</span>
          
          <div style={{display: 'flex', flexDirection: 'row'}}>
          <span className="name text-dark">{name}</span>
          {circleColor && (
          <span className="circle-container"
                      style={{ backgroundColor: circleColor }}></span>
                    ) || (
                      <CircularProgress variant="solid" size='sm' color='neutral'/>
                    )}
          </div>
      </div>
      <div className="myrow" >
          <span className="client text-dark">{client}</span>
          <span className="time text-dark">{time}</span>
      </div>
    </div>
  );
}

export default OperationComponent;